<template>
  <v-layout class="center pa-5">
    <v-card class="pa-5" width="500px" height="380px">
      <v-layout column>
        <span class="font-weight-bold mb-5" style="font-size: 1.3em"
          >Zaloguj się do systemu</span
        >
        <v-form v-model="valid" @submit.prevent="loginStandard">
          <v-text-field
            v-model="user.email"
            :rules="[rules.required, rules.counter, rules.email]"
            outlined
            label="login (adres e-mail)"
          ></v-text-field>
          <v-text-field
          type="password"
            v-model="user.password"
            :rules="[rules.required, rules.counter]"
            outlined
            label="hasło"
          ></v-text-field>
          <a class="forgot" @click="dialog = !dialog">Zapomniałeś/aś hasła?</a>
          <!--dałem hrefa żeby przechodziło bo testowałem-->
          <v-layout justify-end
            ><v-btn color="blue" type="submit" :disabled="!valid" dark
              >Zaloguj</v-btn
            ></v-layout
          >
          <div v-if="message" class="alert alert-danger" role="alert">
            {{ message }}
          </div>
        </v-form>
      </v-layout>
    </v-card>

    <v-dialog v-model="dialog" width="500">
      <v-card class="pa-5">
        <span>Podaj adres e-mail używany do logowania</span>
        <v-text-field
          class="mt-2"
          v-model="forgottenemail"
          :rules="[rules.required, rules.counter, rules.email]"
          outlined
          label="adres e-mail"
        ></v-text-field>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="
              dialog = false;
              dialog2 = !dialog2;
            "
          >
            Wyślij przypomnienie
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog2" width="500">
      <v-card class="pa-5">
        <v-layout column>
          <span
            >Wiadomośc z instrukcją zresetowania hasła powinna zostać wyslana
            jeżeli taki adres e-mail jest zarejestrowany.</span
          >
          <v-layout justify-end>
            <v-btn class="mt-3" dark color="blue" @click="dialog2 = false"
              >zamknij</v-btn
            ></v-layout
          >
        </v-layout>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog3" width="500">
      <v-card class="pa-5">
        <v-layout column>
          <span>Błędny e-mail lub hasło!</span>
          <v-layout justify-end>
            <v-btn class="mt-3" dark color="blue" @click="dialog3 = false"
              >zamknij</v-btn
            ></v-layout
          >
        </v-layout>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<style scoped>

.center {
  justify-content: center;
  align-items: center;
}
.forgot {
  width: 42%;
}
</style>
<script>
import User from "../models/user";
export default {
  components: {},
  data() {
    return {
      user: new User("", ""),
      forgottenemail: "",
      message: "",
      valid: true,
      dialog: false,
      dialog2: false,
      dialog3: false,
      rules: {
        required: (value) => !!value || "To pole jest wymagane",

        counter: (value) => value?.length < 50 || "Maksymalnie 50 znaków!!!",
        // email: (value) => {
        //   const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        //   return pattern.test(value) || "Niepoprawny adres E-mail";
        // },
      },
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  created() {
    if (this.loggedIn) {
      this.$router.push("/");
    }
  },
  methods: {
    loginStandard() {
      this.user.username = this.user.email;

      if (this.user.username && this.user.password) {
        this.$store.dispatch("auth/login", this.user).then(
          () => {
            
            this.$router.push("/zamowienia");
          },
          (error) => {
            this.message = error.response.data.message
          }
        );
      }
      
    },
  },
};
</script>
